<template>
  <div class="gallery">
    <div class="images">
      <div
        v-for="(image, index) in imageList"
        :key="image.src.replace('.jpg', '') + index"
        class="image"
        :title="'index:' + index"
        :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
        @click="openLightbox(index)"
      >
        <span v-if="removable" class="absolute top-1 right-1 z-10">
          <JoszakiButton
            type="danger"
            icon-left="trash"
            size="sm"
            :title="removeTitle"
            @click.native.stop="$emit('remove', images[index])"
          />
        </span>
      </div>
    </div>
    <div v-if="lightboxMounted" ref="lightboxPortal">
      <CoolLightBox
        id="z"
        :items="imageList"
        :index="imageIndex"
        @close="imageIndex = null"
      />
    </div>
  </div>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  components: {
    CoolLightBox,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "tender",
    },
    removable: {
      type: Boolean,
      default: false,
    },
    removeTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageIndex: null,
      lightboxMounted: false,
    };
  },
  computed: {
    imageList() {
      const urlMap = {
        tender: {
          thumb: (name) => this.$helpers.getTenderPhotoUrl(name, "thumbnail"),
          src: (name) => this.$helpers.getTenderPhotoUrl(name, "normal"),
        },
        "reference-photo": {
          thumb: (name) => this.$helpers.getReferencePhoto(name, "small"),
          src: (name) => this.$helpers.getReferencePhoto(name),
        },
        "price-offer": {
          thumb: (name) => this.$helpers.getPriceOfferPhoto(name, "thumbnail"),
          src: (name) => this.$helpers.getPriceOfferPhotoUrl(name, "normal"),
        },
      };

      if (!this.type || !urlMap[this.type]) {
        return [];
      }

      return this.images.map((image) => ({
        thumb: urlMap[this.type].thumb(image.name),
        src: urlMap[this.type].src(image.name),
        description: image?.description ?? image.name,
      }));
    },
  },
  beforeDestroy() {
    const portal = this.$refs.lightboxPortal;
    if (portal && portal.parentNode) {
      portal.parentNode.removeChild(portal);
    }
  },
  methods: {
    openLightbox(index) {
      if (this.lightboxMounted) {
        this.imageIndex = index;
        return;
      }

      // CoolLightBox opens via its `index` watcher (null -> number), so mount it
      // first (index still null) and set the index on the next tick so the watcher fires.
      this.lightboxMounted = true;
      this.$nextTick(() => {
        // Move the overlay to <body> so no transformed/contained ancestor (e.g. the
        // conductor app shell) can confine its position:fixed layer to a sub-region.
        if (this.$refs.lightboxPortal) {
          document.body.appendChild(this.$refs.lightboxPortal);
        }
        this.imageIndex = index;
      });
    },
  },
};
</script>

<style scoped>
.image {
  position: relative;
  width: 85px;
  height: 85px;
  padding: 5px;
  background-size: cover;
  background-position: center center;
  display: inline-block;
  margin-right: 1em;
  border-radius: 0.5rem;
  cursor: pointer;
}
</style>
